/* Данные кабинета — только из API. Хуки и выведенные из ответов типы. */
import { trpc } from '@tg/app-core';
import { dateOf, daysBetween, dm, plural, today } from './format';

type U = ReturnType<typeof trpc.useUtils>;
type Data<F extends (...a: any) => any> = NonNullable<ReturnType<F>>;

export type Me = Data<U['trainer']['me']['getData']>;
export type ClientRow = Data<U['trainer']['clients']['getData']>[number];
export type Group = Data<U['trainer']['groups']['getData']>[number];
export type Template = Data<U['trainer']['templates']['getData']>[number];
export type ClientFull = Data<U['trainer']['client']['getData']>;
export type FeedItem = Data<U['trainer']['feed']['getData']>[number];
export type DashData = Data<U['trainer']['dashboard']['getData']>;
export type TplLevel = 'block' | 'workout' | 'program';

export const useMe = () => trpc.trainer.me.useQuery(undefined, { staleTime: 60_000 });
export const useClients = () => trpc.trainer.clients.useQuery(undefined, { staleTime: 60_000 });
export const useGroups = () => trpc.trainer.groups.useQuery(undefined, { staleTime: 60_000 });
export const useGroupsTill = () => trpc.trainer.groupsTill.useQuery(undefined, { staleTime: 60_000 });
export const useTemplates = (level: TplLevel) => trpc.trainer.templates.useQuery({ level }, { staleTime: 5 * 60_000 });

/** Тренируется ли клиент: есть составленные дни или группа. Программа за клиентом не закрепляется —
    это лишь способ разом разложить много тренировок (страница программы) */
export const hasProg = (c: Pick<ClientRow, 'composedTill' | 'group'>) => !!(c.composedTill || c.group);

/** Подпись под именем в выборе клиента: группа · докуда составлено (nav.js clientProgSub) */
export function clientProgSub(c: Pick<ClientRow, 'composedTill' | 'group'>) {
  const gl = c.group ? 'группа ' + c.group.name : '';
  const tail = c.composedTill ? 'составлено до ' + dm(c.composedTill) : 'ничего не составлено';
  return (gl ? gl + ' · ' : '') + tail;
}
/** То же для группы: участники · докуда составлено */
export function groupSub(members: number, till: string | null | undefined) {
  return members + ' ' + plural(members, 'участник', 'участника', 'участников') + ' · ' + (till ? 'составлено до ' + dm(till) : 'ничего не составлено');
}

/** Последняя активность клиента — дата в поясе тренера */
export const lastActive = (c: { lastActiveAt: Date | string | null }) => dateOf(c.lastActiveAt);
